import { Observable } from 'rxjs';

import { ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery } from 'application/job/query/observe-job-offers-by-owner-id-and-organization-module-id.query';
import { MoveJobOfferToColumnCmd } from 'job/command/move-job-offer-to-column.cmd';
import { UpdateJobOfferDocumentCmd } from 'job/command/update-job-offer-document.cmd';
import { JobOfferDocumentOutput } from 'job/model/job-offer-document.output';
import { JobOfferOutput } from 'job/model/job-offer.output';

import { SaveJobOfferCmd } from '../command/save-job-offer.cmd';

export abstract class JobOfferApiPort {
	public abstract createJobOffer(
		cmd: SaveJobOfferCmd
	): Observable<JobOfferOutput>;

	public abstract updateJobOffer(
		cmd: SaveJobOfferCmd
	): Observable<JobOfferOutput>;

	public abstract fetchJobOffersByOwnerIdAndOrganizationModuleId(
		query: ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery
	): Observable<JobOfferOutput[]>;

	public abstract fetchJobOffersByIds(
		ids: string[]
	): Observable<JobOfferOutput[]>;

	public abstract fetchJobOfferById(id: string): Observable<JobOfferOutput>;

	public abstract generateModuleDocumentUrl(
		file: File
	): Observable<JobOfferDocumentOutput>;

	public abstract updateJobOfferDocument(
		cmd: UpdateJobOfferDocumentCmd
	): Observable<JobOfferOutput>;

	public abstract moveJobOfferToColumn(
		cmd: MoveJobOfferToColumnCmd
	): Observable<JobOfferOutput>;
}
